<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center" style="margin-top:100px">
      <div class="col-xl-6 col-lg-6 col-md-6">
        <div class="card o-hidden border-0 shadow-sm mt">
          <div class="card-body p-0">
            <div class="row justify-content-center">
              <!-- <div class="col-lg-6 d-none d-lg-block"></div> -->
              <div class="col-lg-10 col-md-10 col-sm-10">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">{{appname}} Online системд нэвтэрнэ үү!</h1>
                  </div>
                  <br/>
                  <div class="user" autocomplete="off">
                    <div  v-if="loading==false">
                      <button @click="studentLogin" type="button" class="btn btn-primary btn-block">
                        Сурагч
                      </button>
                      <button @click="teacherLogin" type="button" class="btn btn-google btn-block">
                        Багш 
                      </button>

                      <hr/>
                      <button title="Сурагч код, регистрээ xийж нэг удаагийн горимоор нэвтрэx боломжтой." @click="$router.push({ 'name':'FinalScores' , params:{ }})" type="button" class="btn btn-success btn-block">
                        Нэг удаа нэвтрэx
                      </button>
                      <p>V1.1.1</p>
                      <!-- <hr/>
                      <div class="btn btn-outline-secondary gr-default-outline-btn btn-block" @click="_registerTeacher">Багш бүртгүүлэx</div> -->
              
                    </div>
                  
                    <button type="button" v-else class="btn btn-google btn-block" disabled>
                      <span class="spinner-border spinner-border-sm"></span>
                      Loading..
                    </button>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
export default {
  name: "Adminman",
  data() {
    return {
      loading:false,
      appname: null,
      showlogo: null,
      logopath:null
    };
  },
  created(){
      if(fb.APPNAME)
        this.appname=fb.APPNAME;
      if(fb.SHOWLOGO)
        this.showlogo=fb.SHOWLOGO;
      if(fb.LOGOPATH)
        this.logopath=fb.LOGOPATH;
  },
  methods: {
    _registerTeacher(){
      this.$router.push({name:'TeacherAddFromPublic', params:{ teacherId:'new', schoolId:'keXpQvNR6qzNbJMWZ1A2'}})
    },
    teacherLogin() {
      this.loading=true;
      this.$router.push('/teacherlogin');
    },
    studentLogin(){
      this.loading=true;
      this.$router.push('/studentlogin');

    }
  }
};
</script>

